module.exports = function(object) {
    return Object.keys(object).length === 0;
};
